<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Marcas">
          <listar-marca />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarMarca from '@/components/administrativo/veiculo/marca/ListarMarca'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de marcas',
      },
      breadcrumbs: [
        {
          text: 'Sistema',
          disabled: true,
        },
        {
          text: 'Veículos',
          disabled: true,
        },
        {
          text: 'Marcas',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarMarca,
  },
}
</script>

<style></style>
